<template>
  <h1
    v-if="level === 1"
    :class="
      twMerge(
        'font-serif text-4xl font-bold leading-none text-black lg:text-5xl lg:leading-snug',
        customStyle,
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </h1>
  <h2
    v-if="level === 2"
    :class="
      twMerge(
        'font-serif text-3xl font-bold leading-none text-black lg:text-5xl lg:leading-snug',
        customStyle,
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </h2>
  <h3
    v-if="level === 3"
    :class="
      twMerge(
        'font-serif text-2xl font-bold leading-none text-black lg:text-[28px] lg:leading-snug',
        customStyle,
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </h3>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

interface Props {
  customStyle?: string
  level?: 1 | 2 | 3
}

withDefaults(defineProps<Props>(), {
  level: 1,
})
</script>
